import styled from 'styled-components';

export const Group = styled.section`
  display: flex;
  gap: 60px;

  & > div:nth-child(2) {
    padding-left: 60px;
    border-left: 1px solid ${({ theme }) => theme.colors.grey.white};
  }
`;

export const Collumn = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 36px;
`;

export const GroupInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    font-size: 24px;
    font-family: 'Bebas Neue', sans-serif;
  }
`;

export const Content = styled.div`
  width: 100%;

  input {
    width: 100%;
    padding: 12px 8px;
    border-radius: 8px;
    font-size: 20px;
    font-weight: 300;
    border: 0;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 16px;
      padding: 8px;
    }
  }
`;

export const Selected = styled.div`
  margin-bottom: 8px;

  span {
    font-weight: 400;
    font-style: italic;
    color: ${({ theme }) => theme.colors.grey[500]};
  }
`;

export const Bubble = styled.label`
  display: flex;
  margin: 2px 0;
  padding: 12px;
  background-color: ${({ theme }) => theme.colors.grey[600]};
  color: ${({ $checked, theme }) =>
    $checked ? theme.colors.primary.main : theme.colors.grey.white};
  border: 1px solid
    ${({ $checked, theme }) =>
      $checked ? theme.colors.primary.main : theme.colors.grey[800]};
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    transition: 0.7s;
    opacity: 0.8;
  }
`;

export const ButtonRemove = styled.button`
  width: 100%;
  padding: 8px;
  margin-top: 4px;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.grey[200]};

  &:hover {
    transition: 0.7s;
    opacity: 0.8;
  }
`;
